/**
 * @classdesc Canadian French Language Pack
 * @desc This class will used to translate tokens into the Canadian French language.
 * @namespace Languages.CanadianFrench
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.CanadianFrench
 */
export const dictionary = {
    'years'   : 'Ans',
    'months'  : 'Mois',
    'days'    : 'Jours',
    'hours'   : 'Heures',
    'minutes' : 'Minutes',
    'seconds' : 'Secondes'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.CanadianFrench
 */
export const aliases = ['fr', 'fr-ca', 'french'];
